import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import PaymentsOSErrorLabel from './PaymentsOSErrorLabel';

const PaymentsOSCvvForm = React.forwardRef(({ config, savedPaymentMethod, onResult }, ref) => {

    const { t } = useTranslation();
    const [errorCvv, setErrorCvv] = React.useState(undefined);

    const create = useCallback(() => {
        const style = {
            base: {
                backgroundColor: '#FFFFFF',
                fontSize: '18px',
                padding: '6px',
                textAlign: 'start',
                width: '55px'
            },
        };

        // pass the public key
        window.POSC.setPublicKey(config.public_key);
        // set the environment
        window.POSC.setEnvironment(config.production ? 'live' : 'test');
        // pass the card's token
        window.POSC.setPaymentToken(savedPaymentMethod.token);
        // set a placeholder
        window.POSC.setSecurityNumberPlaceholder('123');
        // set style
        window.POSC.setStyle(style);
        // initialize the form's field
        window.POSC.initCvvEncryptor('cvv-field');

    }, [config, savedPaymentMethod]);

    useEffect(() => {
        const script = window.document.createElement('script');
        script.src = 'https://js.paymentsos.com/cvv/latest/cvv-encryptor.min.js';
        script.onload = create;
        window.document.body.appendChild(script);
        return () => window.document.body.removeChild(script);
    }, [create]);

    React.useImperativeHandle(ref, () => ({
        tokenize() {
            try {
                return window.POSC.createTokenById('cvv-field', function(result) {
                    onResult(result);
                });
            } catch(e) {
                console.log(e);
            }
        },
        hasCvvError() {
            setErrorCvv('error');
        }
    }));

    return (
        <div>
            <label>{t('cvcLabel')}</label>
            <div id="cvv-field" className="wz-lyriapay-paymentsos-form-div"></div>
            <PaymentsOSErrorLabel
                content={
                    errorCvv ? t('cvcInvalid') : null
                }
            />
        </div>
    );
});

PaymentsOSCvvForm.propTypes = {
    config: PropTypes.object,
    savedPaymentMethod: PropTypes.object,
    onResult: PropTypes.func
};

PaymentsOSCvvForm.displayName = 'PaymentsOSCvvForm';

export default PaymentsOSCvvForm;